import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBsNziUbudNPpSVhKXEhqiRDPf3KFRdQJc",
  authDomain: "study-info-centre.firebaseapp.com",
  projectId: "study-info-centre",
  storageBucket: "study-info-centre.appspot.com",
  messagingSenderId: "619525662126",
  appId: "1:619525662126:web:849c6ac1d719998763943f",
  measurementId: "G-1NB5V7GDKT"
};

const app = initializeApp(firebaseConfig);

export const authentication = getAuth(app);
